var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "emap-uploadfile"
  }, [_c('el-upload', {
    ref: "emapUploadFile",
    class: _vm.uploadClass,
    attrs: {
      "disabled": _vm.readonly,
      "multiple": _vm.multiple,
      "list-type": _vm.listType,
      "action": _vm.action,
      "data": _vm.formData,
      "before-upload": _vm.beforeUpload,
      "on-progress": _vm.handleProgress,
      "on-success": _vm.handleSuccess,
      "on-preview": _vm.handlePreview,
      "before-remove": _vm.beforeRemove,
      "on-remove": _vm.handleRemove,
      "limit": _vm.limit,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileArr,
      "show-file-list": _vm.showFileList
    }
  }, [_vm.listType === 'avatar' ? _c('div', [_vm.avatarSrc ? _c('el-image', {
    staticClass: "avatar-uploader__img",
    style: {
      height: `${_vm.avatarSize}px`,
      width: `${_vm.avatarSize}px`
    },
    attrs: {
      "src": _vm.avatarSrc
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader__icon",
    style: {
      height: `${_vm.avatarSize}px`,
      width: `${_vm.avatarSize}px`,
      lineHeight: `${_vm.avatarSize}px`
    }
  })], 1) : !_vm.readonly ? _c('div', [_vm.listType === 'text' ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-upload2"
    }
  }, [_vm._v(" 点击上传 ")]) : _vm._e(), _vm.listType === 'picture-card' ? _c('i', {
    staticClass: "el-icon-plus"
  }) : _vm._e()], 1) : _vm._e(), !_vm.readonly ? _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._t("uploadTip")], 2) : _vm._e()]), _c('upload-file-list', {
    attrs: {
      "file-arr": _vm.fileArr,
      "readonly": _vm.readonly,
      "list-type": _vm.listType,
      "can-preview-all-file": _vm.canPreviewAllFile
    },
    on: {
      "handlePreview": _vm.handlePreview,
      "handleRemove": _vm.handleRemoveCustom
    }
  }), _vm.src || _vm.previewSrcList.length > 0 ? _c('el-image', {
    ref: "imagePreviewer",
    staticClass: "image-preview",
    attrs: {
      "src": _vm.src,
      "preview-src-list": _vm.previewSrcList
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };